// ----------------------------
// Created by Bulletproof Games
//            2021
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Game Loader
//

Loader = {};
Loader.isLoaded = false;
Loader.minTimerExpired = false;
Loader.readyForSplash = false;

autoplayManager.containerName = 'autoplayContainer:autoplayBackground';

Loader.initialise = function (container) {
  Loader.container = container;

  // Setup callback functions
  resourceManager.registerLoadCompleteCallback(Loader.onLoadComplete);
  resourceManager.registerLoadProgressCallback(Loader.onLoadProgress);
  Reflex.registerEventHandler('ready', Loader.onLayoutComplete);
};

Loader.onResize = function (width, height, isLandscape) {
  // if (Loader.loaderBackground !== undefined) {
  //   var scale = Math.max(
  //     width / Loader.loaderBackground.texture.width,
  //     height / Loader.loaderBackground.texture.height
  //   );
  //   Loader.loaderBackground.scale.x = scale;
  //   Loader.loaderBackground.scale.y = scale;
  //   Loader.loaderBackground.position.x = width / 2;
  //   Loader.loaderBackground.position.y = height / 2;
  // }
};

Loader.onLoadComplete = function (loadGroup, resources) {
  if (loadGroup === 'loading') {
    // globalThis.__PIXI_APP__ = systemData.renderer;
    globalThis.__PIXI_STAGE__ = systemData.stage;
    globalThis.__PIXI_RENDERER__ = systemData.renderer;

    Loader.progressBar = resourceManager.get('loadingProgressBar');
    // Loader.loaderBackground = resourceManager.get('loadingProgressBack');

    resourceManager.getContainer('loadingContainer').visible = true;
    resourceManager.getContainer('backgroundContainer').visible = false;
    resourceManager.getContainer('splashContainer').visible = false;
    resourceManager.getContainer('fsBackgroundContainer').visible = false;

    Loader.loadMask = resourceManager.get('loadingMask');
    Loader.loadMask.pivot.x = 0;
    Loader.progressBar.mask = Loader.loadMask;

    Loader.setLoadProgress(0);

    const loadingData = gdk.getPlatformLoadingData();
    let isGamCareLogoVisible = checkForDefined(loadingData.gamCareLogo) ? loadingData.gamCareLogo : false;
    let isPreloadMessageVisible = checkForDefined(loadingData.message);
    resourceManager.get('GamCareContainerPreLoad:gamCareLogo').visible = isGamCareLogoVisible;
    resourceManager
      .get('GamCareContainerPreLoad:preLoadMessage')
      .setText(isPreloadMessageVisible ? loadingData.message : '');
    resourceManager.get('GamCareContainerPreLoad').visible =
      isGamCareLogoVisible || (isPreloadMessageVisible && loadingData.message.length != 0);

    if (isPreloadMessageVisible) {
      // YG requirement, we need to give player 5 seconds to read preloader message
      timerManager.addTimer(5000, undefined, function () {
        Loader.minTimerExpired = true;
        Loader.checkCanGoToSplash();
      });
    } else {
      Loader.minTimerExpired = true;
      Loader.checkCanGoToSplash();
    }
  }
};

Loader.onLoadProgress = function (percent, loadGroup) {
  if (loadGroup !== 'loading') {
    Loader.setLoadProgress(percent);
  }
};

Loader.onLayoutComplete = function () {
  Loader.setLoadProgress(1);
  gameData.stakeMeter = resourceManager.get('meterContainer:stake:meter');
  gameData.creditMeter = resourceManager.get('meterContainer:credit:meter');
  gameData.winningsMeter = resourceManager.get('meterContainer:winnings:meter');
  gameData.winningsMeterTitle = resourceManager.get('meterContainer:winnings:title');
  gameData.screenDim = resourceManager.get('backgroundScreenDimObject');

  // hide the old original reels
  // we need to keep these here as they help setup the anim strips etc which the game
  // still uses, so we cant remove them, and i dont want to rewrite something that works
  for (let i = 0; i < reelManager.reels.length; i++) {
    reelManager.reels[i].renderable = false;
    reelManager.reels[i].parent.removeChild(reelManager.reels[i]);
  }

  //messageBus.subscribe("spinner:GameConfigEvent", Loader.onGameConfigEvent);

  // loading bar finished - hide now whilst waiting for player to continue
  // resourceManager.get( "loader:loadingBarBack" ).visible = false;
  // resourceManager.get( "loader:loadingBarFrame" ).visible = false;
  // resourceManager.get( "loader:loadingProgressBack" ).visible = false;
  // resourceManager.get( "loader:loadingText" ).visible = false;
};

Loader.onGameConfigEvent = function (gameConfigTask) {
  gameData.reels = [];
  gameData.reelAnimations = [];
  gameData.bonusSymbols = [];
  gameData.inputOverlord = resourceManager.getController('inputOverlord');
  gameData.inputOverlord.setState('disabled');
  gameData.slotConfig = gameConfigTask.data.slotConfig;

  gameData.maxExposure = gameConfigTask.data.maxExposure;

  if (gameConfigTask.data.savedClientData) {
    var encoreData = gameConfigTask.data.savedClientData.meta.find(function (element) {
      return element.name === 'encore';
    });
  }

  var enableEncoreButton = encoreData && encoreData.enabled;

  if (enableEncoreButton && !gameConfigTask.data.slotConfig.promotionActive) {
    // task.data.metaValue is set to true if recovering encore game
    gameData.encoreEnabled = true;

    // Put button in the right state if not already true
    var encoreButtonLB = resourceManager.get('extraButtonsContainer:luckyBetToggleButton');

    if (encoreButtonLB._flags.showLuckyBetActive !== gameData.encoreEnabled) {
      encoreButtonLB.setRecovery();
    }

    resourceManager.getController('stakeController').setStakeMultiplier(encoreData.value);
    game.changeStake(resourceManager.getController('stakeController').CurrentStake);
    resourceManager.getController('stakeController').broadcastCurrentStake();
  }

  gameData.slotConfig = gameConfigTask.data.slotConfig;

  // needed for when we alter the offsets with anticipation
  game.baseStopDistances = gameConfigTask.data.stopDistances;
  game.stopDistances = gameConfigTask.data.stopDistances;

  game.gambleChances7To10 = gameConfigTask.data.gambleChances7To10;
  game.gambleChances10To13 = gameConfigTask.data.gambleChances10To13;

  // Link buttons to functions
  game.initialise(gameConfigTask);

  var slotMachine = slotMachineFactory.getSlotMachine(0);
  slotMachine.selectReelMode('standard');
  // All objects are created, so create game specific data
  for (var i = 0; i < slotMachine.reels.length; i++) {
    let reel = resourceManager.get('slotContainer:reelContainer:reel' + i);

    let startingSymbols = gameData.slotConfig.loadingBoard.board.stopWindow.reelList[i].symbols;
    let reelLength = startingSymbols.length;

    // Copy starting symbols from server
    for (var j = 0; j < reelLength; ++j) {
      reel.setReelSymbol(j, startingSymbols[j].value);
    }

    // using a closure to pass through the correct reelID
    reel.spinCompleteCallback = (function () {
      var reelID = i;
      return function () {
        if (freespins.inFreespins) {
          freespins.onSpinComplete(reelID);
        } else {
          gameController.onSpinComplete(reelID);
        }
      };
    })();

    // reel.initialDropCompleteCallback = ( function() {
    //     var reelID = i;
    //     return function() {
    //         if ( freespins.inFreespins ) {
    //             freespins.initialDropComplete( reelID );
    //         } else {
    //             gameController.initialDropComplete( reelID );
    //         }
    //     };
    // })();

    gameData.reels.push(reel);
    gameData.reelAnimations.push(
      resourceManager.get('slotContainer:reelContainer:reel' + i + ':animationStripContainer:' + 'reelAnimStrip' + i)
    );
  }

  Loader.readyForSplash = true;
  Loader.checkCanGoToSplash();
};

Loader.checkCanGoToSplash = function () {
  if (Loader.readyForSplash && Loader.minTimerExpired) {
    Loader.readyForSplash = false;
    Loader.minTimerExpired = false;
    resourceManager.getContainer('loadingContainer').visible = false;
    game.goToSplash();
  }
};

Loader.setLoadProgress = function (percent) {
  var width = Loader.progressBar.texture.baseTexture.width * percent;
  var height = Loader.progressBar.texture.baseTexture.height;
  Loader.loadMask.clear();
  Loader.loadMask.beginFill(0xffffff);
  Loader.loadMask.drawRect(0, 0, width, height);
  Loader.loadMask.endFill();
};

messageBus.subscribe('spinner:GameConfigEvent', Loader.onGameConfigEvent);
